<template>
    <div class="instance">
      <div class="params" v-bind:class="{ free: instance.isFree }">
        <p class="name">{{instance.name}}</p>
        <p class="version" @click="changeInstanceVersion(instanceIndex, instance.url, instance.version)">{{instance.version}}</p>
        <p><a target="_blank" :href="instance.url">{{instance.url}}</a></p>
      </div>
      <Services
        v-bind:services="instance.services"
        v-bind:instanceIndex="instanceIndex"
        v-bind:instanceUrl="instance.url"
      />
    </div>
</template>

<script>
import Services from '@/components/Services.vue'
export default {
  name: 'Instance',
  props: {
    instance: {
      type: Object,
      requierd: true  
    },
    instanceIndex: Number
  },
  components: {
    Services
  },
  methods: {
    changeInstanceVersion(instanceIndex, instanceUrl, version) {
      const data = {type: "instance", instanceIndex: instanceIndex, instanceUrl: instanceUrl, inputText: version}
      this.$root.$refs.App_component.openModal(data);
    }
  }
}
</script>

<style>
  .instance {
    width: 100%;
    float: left;
    position: relative;
    border: bottom 1px solid;
    margin-top: 20px;
  }
  .params {
    width: 100%;
    display: block;
    background-color: #4787ffaa;
  }
  .free {
    background-color: #04AA6D
  }
  .instance .params .name {
    font-weight: bold;
    font-size: 20px;
    width: 120px;
  }
  .instance .params .version {
    width: 200px;
  }
  li {
    position: relative;
    width: 100%;
    padding: .5rem 2rem;
    margin-bottom: 1rem;
  }
  p {
    display: inline-block;
    margin: 10px;
  }
</style>